import { HttpErrorResponse } from '@angular/common/http';

export function isOfflineFallbackError(error: unknown): boolean {
  if (error instanceof HttpErrorResponse) {
    return error.status === 0 || error.status >= 500;
  }

  if (error !== null && typeof error === 'object' && 'status' in error) {
    const status = error.status;

    return typeof status === 'number' && (status === 0 || status >= 500);
  }

  return false;
}
